import React, { useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import './DrProfileView2.css';
import { FaCheckCircle, FaLaptop ,FaBriefcase  } from "react-icons/fa";



function DrProfileView2() {



  return (
    <div className='DrPofileView2-container mx-auto'>


      <div className="Drprofileview2-header">
        <FaLaptop topCode size={37}  className="Drprofileview2-icon" />
        <span className="Drprofileview2-title">Your preference for job </span>
      </div>
      <div className="Drprofileview1-card-body">

        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" /> Prefer job Location

        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">Qatar</div>
          <div className="Drprofileview2-box">Dubai</div>
          <div className="Drprofileview2-box">Singapore</div>

        </div>

        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" />I would like to start my job

        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">12/05/2025</div>

        </div>

        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" />Job position I am applying for

        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">Neurologist</div>

        </div>

        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" /> My Expectation
        </h5>

        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">
            <div className="Drprofileview2-item">
              <span className="drprofileview2-dot"></span>
              <span>Salary - Negotiable</span>
            </div>
            <div className="Drprofileview2-item">
              <span className="drprofileview2-dot"></span>
              <span>Day Off - Flexible</span>
            </div>
            <div className="Drprofileview2-item">
              <span className="drprofileview2-dot"></span>
              <span>Accommodation-: Live in - Separate room</span>
            </div>
          </div>
        </div>


        <div className="Drprofileview2-header">
          <FaBriefcase size={37} className="Drprofileview2-icon" />
          <span className="Drprofileview2-title">What is your previous experienced </span>
        </div>


        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" /> My Previous Medical Specialties Job Position

        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">Neurologist</div>


        </div>

        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" /> My Previous Surgical Specialties Job Position

        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">Neurosurgeon</div>


        </div>

        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" /> Other Medical Specialties Job Position (Previous)


        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">Pain Management Specialist
          </div>


        </div>

        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" /> My Previous Academic and Research Job Position


        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">Medical Educator
          </div>


        </div>

        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" /> My Previous Administrative and Leadership Job
          Position


        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">Hospital Administrator
          </div>


        </div>

        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" />Country have worked before
          Position


        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">Qatar
          </div>
          <div className="Drprofileview2-box">Dubai
          </div>
          <div className="Drprofileview2-box">Singapore
          </div>
          <div className="Drprofileview2-box">Japan
          </div>


        </div>


        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" /> Reference letter from your previous employer
          Position


        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">No
          </div>


        </div>
        <h5 className="Drprofileview2-title mt-4">
          <FaCheckCircle className="Drprofileview2-check-icon" /> I Have valid passport

          Position


        </h5>
        <div className="drprofileview2-row">
          <div className="Drprofileview2-box">Yes
          </div>


        </div>

<div>
   <h5 className="Drprofileview2-title-aboutme mt-4 ">About Me</h5>
   <div className="Drprofileview2-aboutme-box ">
 

  <p>
    Hello sir,<br />
    Hello, I'm Dr. Yasmin, a dedicated and compassionate medical professional
    with a strong passion for delivering exceptional patient care. With a
    wealth of experience and expertise in my field, I am committed to
    providing high-quality healthcare services that prioritize patient
    well-being and satisfaction.
  </p>

  <p>Regards</p>

</div>
  <div className="Drprofileview2-report">Report about this post</div>

</div>











      </div>

    </div>
  );

}

export default DrProfileView2;